import { useSelector } from 'react-redux';

const useJurisdictionBounds = () => {
  // Shapes is an array of [ { bottom_right: { lat: 0, lng: 0 }, top_left: { lat: 0, lng: 0 } } ]
  const shapes = useSelector(
    state => state.geofences?.currentGeofence?.shapes || [],
  );

  // Go through shapes and build a bounding box that can be used with the Google Maps Geocoding API without
  // using the API just yet, but in a friendly format so this hook is not tightly coupled to the Google API.
  const bounds = shapes.map(shape => ({
    northeast: {
      lat: shape.top_left.latitude,
      lng: shape.bottom_right.longitude,
    },
    southwest: {
      lat: shape.bottom_right.latitude,
      lng: shape.top_left.longitude,
    },
  }));

  if (!bounds.length) {
    return null;
  }

  // Combine all the bounds into a single bound.
  const singleBounds = bounds.reduce((acc, curr) => {
    return {
      northeast: {
        lat: Math.max(acc.northeast.lat, curr.northeast.lat),
        lng: Math.max(acc.northeast.lng, curr.northeast.lng),
      },
      southwest: {
        lat: Math.min(acc.southwest.lat, curr.southwest.lat),
        lng: Math.min(acc.southwest.lng, curr.southwest.lng),
      },
    };
  });

  return singleBounds;
};

export default useJurisdictionBounds;
